export default function checkImageURL(url: string): boolean {
  return(url.match(/\.(jpeg|jpg|gif|png)/) != null);
}

